<template>
    <div class="carouselSlide" :class="classIndex" :style="componentBgColor" v-if="showSwiper">
        <div class="swiper" :style="paddingStyle">
            <div class="search" @click="goSeacher" v-if="datas.showSearch">
                <i class="iconfont iconsousuo"></i>
                <p>请输入您感兴趣的内容</p>
            </div>
            <div class="weather" :style="weatherStyle" v-if="weather.type">
                <img class="weather_icon" :src="weather.icon">
                <div class="weather_info">
                    <div class="weather_info_lf">
                        <div class="today">今天</div>
                        <div class="weather_temperature">{{ weather.average }}℃</div>
                    </div>
                    <div class="weather_name">
                        {{ weather.type }}
                    </div>
                </div>

            </div>
            <template v-if="datas.items && datas.items.length > 0">
                <div class="swiper-wrap-sigle" :style="style" v-if="datas.csstype == 'sigle-image'"
                    @click="goPage(datas.items[0])">
                    <div class="titles" v-if="datas.items[0].title || datas.items[0].subTitle" :style="titlesStyle">
                        <div class="title" v-if="datas.items[0].title" :style="titleStyle">{{ datas.items[0].title }}
                        </div>
                        <div class="subTitle" v-if="datas.items[0].subTitle" :style="subStyle">
                            {{ datas.items[0].subTitle }}</div>
                    </div>
                    <img :src="datas.items[0].url" :style="imgStyle">
                </div>
                <div class="swiper-draw-zone" :style="style" v-if="datas.csstype == 'swiper-draw-zone'">
                    <div class="swiper-slide" v-for="(item, index) in datas.items" :key="index">

                        <img class="slider-img" :src="item.url" @click="goPage(item)" :style="imgStyle">
                        <div class="zone" v-for="(zone, j) in item.drawZone" :key="j"
                            v-if="item.drawZone && datas.csstype == 'swiper-draw-zone'" @click="toPage(zone.url)"
                            :style="`left:${zone.x * scale}rem;top:${zone.y * scale}rem;width:${zone.w * scale}rem;height:${zone.h * scale}rem;`">
                        </div>

                    </div>

                </div>

                <div class="swiper-wrap" :class="datas.csstype" :style="style" v-else>
                    <!-- <div class="title" v-if="datas.title">{{datas.title}}</div> -->
                    <div class="swiper-list" v-if="displayMultiple == 1">
                        <div class="swiper-box-item" v-for="(item, index) in datas.items" :key="index"
                            @click="goPage(item)">
                            <div class="titles" v-if="item.title || item.subTitle" :style="titlesStyle">
                                <div class="title" v-if="item.title" :style="titleStyle">{{ item.title }}</div>
                                <div class="subTitle" v-if="item.subTitle" :style="subStyle">{{ item.subTitle }}</div>
                            </div>
                            <img class="slider-img" :src="item.url" :style="imgStyle">
                        </div>
                    </div>
                    <div class="swiper-wrapper" v-else>
                        <div class="swiper-slide" v-for="(item, index) in datas.items" :key="index"
                            @click="goPage(item)">
                            <div class="titles" v-if="item.title || item.subTitle" :style="titlesStyle">
                                <div class="title" v-if="item.title" :style="titleStyle">{{ item.title }}</div>
                                <div class="subTitle" v-if="item.subTitle" :style="subStyle">{{ item.subTitle }}</div>
                            </div>
                            <img class="slider-img" :src="item.url" :style="imgStyle">

                        </div>
                    </div>
                    <div class="dots" :class="{ 'hasModules': datas.hasModules }"></div>

                </div>
            </template>
            <div class="navbar" v-if="datas.modulesItems && datas.hasModules" :style="navStyle">
                <div class="navbar-list">
                    <div class="navbar-item" v-for="(module, index) in datas.modulesItems" :key="index"
                        @click="goPage(module)" :class="{ 'navbar-item-five': datas.rowNum && datas.rowNum == '5' }">
                        <img :src="module.url" />
                        <p :style="fontStyle">{{ module.name }}</p>
                    </div>

                </div>
                <div class="customBtnBox" v-if="datas.showBt">
                    <div class="customBtn" :style="customBtnStyle" @click="goPage(datas.btLink)">
                        在线预订
                    </div>
                </div>
            </div>
        </div>

    </div>
</template>

<script>
    import Swiper from "swiper";
    import {
        jAlert3
    } from "@/base/jAlert/jAlert";
    import api from "@/utils/api";
    import { setStorage, getStorage } from '@/utils/wxuser';
    // 轮播图
    export default {
        props: ["datas"],
        data() {
            return {
                swiperCurrent: 0,
                classIndex: '',
                scale: 1, //比例
                weather: {},
                displayMultiple: 0,
                weatherList: [{
                    icon: 'https://xcx.ihotel.cn/mall/images/weather/大到暴雪.png',
                    name: "大到暴雪"
                },
                {
                    icon: 'https://xcx.ihotel.cn/mall/images/weather/大到暴雨.png',
                    name: "大到暴雨"
                },
                {
                    icon: 'https://xcx.ihotel.cn/mall/images/weather/大雪.png',
                    name: "大雪"
                },
                {
                    icon: 'https://xcx.ihotel.cn/mall/images/weather/大雨.png',
                    name: "大雨"
                },
                {
                    icon: 'https://xcx.ihotel.cn/mall/images/weather/多云.png',
                    name: "多云"
                },
                {
                    icon: 'https://xcx.ihotel.cn/mall/images/weather/雷阵雨.png',
                    name: "雷阵雨"
                },
                {
                    icon: 'https://xcx.ihotel.cn/mall/images/weather/霾.png',
                    name: "霾"
                },
                {
                    icon: 'https://xcx.ihotel.cn/mall/images/weather/晴.png',
                    name: "晴"
                },
                {
                    icon: 'https://xcx.ihotel.cn/mall/images/weather/雾.png',
                    name: "雾"
                },
                {
                    icon: 'https://xcx.ihotel.cn/mall/images/weather/小到中雪.png',
                    name: "小到中雪"
                },
                {
                    icon: 'https://xcx.ihotel.cn/mall/images/weather/小到中雨.png',
                    name: "小到中雨"
                },
                {
                    icon: 'https://xcx.ihotel.cn/mall/images/weather/小雪.png',
                    name: "小雪"
                },
                {
                    icon: 'https://xcx.ihotel.cn/mall/images/weather/雨夹雪.png',
                    name: "雨夹雪"
                },
                {
                    icon: 'https://xcx.ihotel.cn/mall/images/weather/预警.png',
                    name: "预警"
                },
                {
                    icon: 'https://xcx.ihotel.cn/mall/images/weather/阴.png',
                    name: "阴"
                },
                {
                    icon: 'https://xcx.ihotel.cn/mall/images/weather/阵雨.png',
                    name: "阵雨"
                },
                {
                    icon: 'https://xcx.ihotel.cn/mall/images/weather/中到大雪.png',
                    name: "中到大雪"
                },
                {
                    icon: 'https://xcx.ihotel.cn/mall/images/weather/中到大雨.png',
                    name: "中到大雨"
                },
                {
                    icon: 'https://xcx.ihotel.cn/mall/images/weather/中雪.png',
                    name: "中雪"
                },
                {
                    icon: 'https://xcx.ihotel.cn/mall/images/weather/中雨.png',
                    name: "中雨"
                },
                {
                    icon: 'https://xcx.ihotel.cn/mall/images/weather/小雨.png',
                    name: "小雨"
                },
                ],
                showSwiper:false,
                user: getStorage('user'),
            };
        },

        computed: {
            fontStyle() {
                var style = "";
                if (this.datas.modulesFontSize) {
                    style += `font-size:${this.datas.modulesFontSize};`;
                }
                return style;
            },
            customBtnStyle() {
                console.log(this.datas)
                var style = ""
                if (this.datas.btShadow) {
                    style += `box-shadow: 0px 8px 16px 0px rgba(0,0,0,0.2);`
                }
                if (this.datas.btTextcolor) {
                    style += `color: ${this.datas.btTextcolor};`
                }
                if (this.datas.btColor) {
                    style += `background: ${this.datas.btColor};`
                }
                return style
            },
            navStyle() {
                var style = ""
                if (this.datas.moduleShadow) {
                    style = `box-shadow: 0 6px 12px 0 rgba(74, 112, 196, 0.06);`
                }
                return style
            },
            componentBgColor() {
                return `background:${this.datas.componentBgColor};`
            },
            paddingStyle() {
                return `margin:0 ${this.datas.padding / 37.5}rem;`
            },
            weatherStyle() {
                var style = ""
                if (this.datas.showWeather) {
                    style = `bottom:${this.datas.weatherBottom / 37.5}rem;right:${this.datas.weatherRight / 37.5}rem;`
                }
                return style
            },
            style() {
                var style = ""
                var w = (375 - this.datas.padding * 2) / 37.5

                if (this.datas.csstype == 'swiper-full-small') {
                    var h = w * (400 / 750)
                } else if (this.datas.csstype == 'swiper-full-big') {
                    var h = w * (500 / 750)
                } else if (this.datas.csstype == 'swiper-full-smallNew') {
                    var h = w * (180 / 750)
                }
                //边距缩放与1.4后台倍数
                var scaleDrp = 1
                try {
                    scaleDrp = window.document.documentElement.getBoundingClientRect().width / window.document.documentElement.style.fontSize.split('px')[0] / 10;
                } catch (e) { }

                this.scale = w / 10 / 37.5 / 1.4 * scaleDrp
                if (this.datas.csstype != 'sigle-image' && this.datas.csstype != 'swiper-full-auto' && this.datas.csstype != 'swiper-draw-zone' && this.datas.csstype != 'swiper-between') {
                    style += `height:${h}rem;`
                }

                if (this.datas.shadow == 'shadow' && this.datas.csstype != 'swiper-between') {
                    style += `box-shadow:0px 6px 12px 0px rgba(74, 112, 196, 0.1);`
                }
                if (this.datas.radius == 'circular') {
                    style += `border-radius:0.213333rem;`
                }
                return style
            },
            imgStyle() {
                var style = ''
                if (this.datas.csstype == 'swiper-between' && this.datas.shadow == 'shadow') {
                    style += `box-shadow:0px 6px 12px 0px rgba(74, 112, 196, 0.1);`
                }
                if (this.datas.radius == 'circular') {
                    style += `border-radius:0.213333rem;`
                }
                if (this.datas.csstype == 'swiper-between') {
                    style += `width:${this.datas.imgWidth / 37.5}rem;height:${this.datas.imgHeight / 37.5}rem;`
                }
                return style
            },
            thumbSuffix() {
                var thumbSuffix = ''
                if (this.datas.csstype == 'swiper-full-small') {
                    thumbSuffix = "?imageView2/1/w/750/h/400/format/webp&x-oss-process=image/resize,m_fill,w_750,h_400"
                } else if (this.datas.csstype == 'swiper-full-big') {
                    thumbSuffix = "?imageView2/1/w/750/h/500/format/webp&x-oss-process=image/resize,m_fill,w_750,h_500"
                } else if (this.datas.csstype == 'swiper-full-smallNew') {
                    thumbSuffix = "?imageView2/1/w/750/h/280/format/webp&x-oss-process=image/resize,m_fill,w_750,h_180"
                }
                return thumbSuffix
            },
            titlesStyle() {

                if (this.datas.titlePosition == 'left') {
                    return `left:20px;text-align: left;`
                } else if (this.datas.titlePosition == 'center') {
                    return `left:50%;transform: translateX(-50%,-50%);text-align: center;width: calc(100% - 40px);`
                } else if (this.datas.titlePosition == 'right') {
                    return `right:20px;text-align: right;`
                }
            },
            titleStyle() {
                return `color:${this.datas.fontColor};font-size:${this.datas.titleFontSize};font-weight:${this.datas.isBold ? 'bold' : 'normal'};`
            },
            subStyle() {
                return `color:${this.datas.fontColor};font-size:${this.datas.subFontSize};font-weight:${this.datas.isBold ? 'bold' : 'normal'};`
            },
        },
        methods: {
            getWetherList() {
                api.getWetherList({
                    cityName: this.datas.weatherCity
                }).then(res => {
                    if (res.result == 1) {
                        if (res.retVal.length > 0) {
                            this.weather = res.retVal[0]
                            this.weather.average = Math.round((this.weather.high + this.weather.low) / 2)
                            this.weatherList.forEach(item => {

                                if (item.name == this.weather.type) {
                                    this.weather.icon = item.icon
                                }
                            })
                            if (!this.weather.icon) {
                                this.weatherList.forEach(item => {
                                    if (item.name == '预警') {
                                        this.weather.icon = item.icon
                                    }
                                })

                            }
                        }

                    } else {
                        jAlert3(res.msg)
                    }
                })
            },
            goSeacher() {
                this.$router.push({
                    path: "/searchIndex",
                });
            },

            goPage(item) {
                if (item.link != '') {
                    if (item.link.indexOf('http') != -1) {
                        if (item.title != '' && item.title) {
                            if (item.link.indexOf('/mall2/?') != -1) {
                                var links = item.link.split('/mall2/?')
                                if (links[1] && links[1].indexOf('?') != -1) {
                                    item.link = item.link + '&customTitle=' + item.title
                                } else {
                                    item.link = item.link + '?customTitle=' + item.title
                                }
                            }
                        }
                        this.goLink(item.link)

                    } else {
                        jAlert3(item.link)
                        return;
                    }

                }

            },
            toPage(link) {
                if (link != '') {
                    this.goLink(link)

                }

            },
            initSwiper() {
                var autoHeight = false
                if (this.datas.csstype == 'swiper-full-auto') {
                    autoHeight = true
                }
                if (this.datas.csstype == 'swiper-between') {
                    if (this.displayMultiple != 1) {
                        var swiper = new Swiper('.' + this.classIndex + " .swiper-wrap", {
                            autoplay: false,
                            paginationClickable: true,
                            autoplayDisableOnInteraction: false, // 处理手动滑动后，继续自动滑动
                            loop: false,
                            slidesOffsetBefore: 15,
                            slidesOffsetAfter: 15,
                            observer: true,
                            slidesPerView: this.displayMultiple,
                            spaceBetween: 10,
                            observeParents: true,
                            autoHeight: autoHeight
                        });
                    }

                } else {
                    var swiper = new Swiper('.' + this.classIndex + " .swiper-wrap", {
                        autoplay: true,
                        paginationClickable: true,
                        autoplayDisableOnInteraction: false, // 处理手动滑动后，继续自动滑动
                        loop: this.datas.items.length > 1,
                        observer: true,
                        observeParents: true,
                        autoHeight: autoHeight,
                        pagination: {
                            el: '.dots',
                        }
                    });
                }

            },
        },
        mounted() {
            this.user = getStorage('user')
            if (this.user && this.user.memberId) {
                ;[this.currentCard] = this.getCurrentCard()
            }
            let cardLevelLimitNum = 0
            if (this.datas.cardLevelLimit) {
                this.datas.cardLevelLimit.forEach(item => {
                    if (item.memberLevelList.length > 0) {
                        cardLevelLimitNum++
                        item.memberLevelList.forEach(level => {
                            if (this.currentCard&&level == this.currentCard.cardLevel) {
                                this.showSwiper = true
                            }
                        })
                    }else if(item.memberCardTypeList){
                        cardLevelLimitNum++
                        if((this.currentCard&&item.memberCardTypeList ==this.currentCard.cardType)||(item.memberCardTypeList=='noMember'&&!this.currentCard)){
                            this.showSwiper = true
                        }
                    } 
                })
            }
            if (cardLevelLimitNum == 0) {
                this.showSwiper = true
            }
            this.classIndex = 'carouselSlide' + this.datas.index
            for (var i = 0; i < this.datas.items.length; i++) {
                var item = this.datas.items[i]
                var cardLevel = this.getQueryVariableCommon(item.link, 'cardLevel')
                var isHide = this.getQueryVariableCommon(item.link, 'isHide')
                if (isHide == 'T') {

                    if (cardLevel) {
                        var allow = false
                        var user = getStorage('user');

                        if (user && user.memberId) {
                            var chuzhiIndex = getStorage("cardIndex") || 0;
                            if (user.cardListDto[chuzhiIndex].cardLevel == cardLevel) {
                                allow = true
                            }
                        }
                        if (!allow) {
                            this.datas.items.splice(i, 1)
                            i--
                        }
                    }
                }
            }

            this.$nextTick(() => {
                if (this.datas.showWeather) {
                    this.getWetherList()
                }
                if (this.datas.csstype == 'swiper-between') {
                    this.displayMultiple = 375 / (Number(this.datas.imgWidth) + 5)
                    if (this.displayMultiple > this.datas.items.length) {
                        this.displayMultiple = 1
                    }
                }
                if (this.datas.items.length && this.datas.items.length > 1) {
                    this.initSwiper()
                }

            })

        }

    };
</script>

<style lang="less">
    @import url("~@/styles/mixin.less");

    .carouselSlide {
        width: 100%;

        .swiper {
            position: relative;
        }

        .titles {
            position: absolute;
            left: 20px;
            top: 50%;
            transform: translateY(-50%);

            .title,
            .subTitle {
                //white-space: nowrap;
            }

            .subTitle {
                margin-top: 0.32rem;
            }

        }

        .search {
            position: absolute;
            display: flex;
            height: 0.933333rem;
            align-items: center;
            justify-content: center;
            top: 0.533333rem;
            left: 5%;
            font-size: 15px;
            width: 90%;
            background: rgba(255, 255, 255, 0.5);
            border-radius: 0.533333rem;
            z-index: 9;
            color: #333;

            .iconsousuo {
                font-size: 15px;
                margin-right: 0.133333rem;
            }

            p {
                font-size: 15px;
            }
        }

        .weather {
            display: flex;
            align-items: center;
            background: #FFFFFF;
            border-radius: 16px;
            position: absolute;
            bottom: 0.533333rem;
            right: 0.533333rem;
            z-index: 2;
            padding: 0.133333rem 0.266667rem;

            .weather_icon {
                height: 0.426667rem;
            }

            .weather_info {
                line-height: 1.4;
                margin-left: 0.133333rem;
                font-size: 8px;
                color: @color-theme;

                .weather_info_lf {
                    padding-top: 1px;
                    display: inline-block;
                }

                .weather_name {
                    vertical-align: top;
                    display: inline-block;
                    max-width: 2em;
                    margin-left: 0.133333rem;
                    color: @color-theme;
                    padding: 0 0.053333rem;
                    border: 1px solid @color-theme;
                    border-radius: 2px;
                    max-height: 22px;
                    overflow: hidden;
                    line-height: 11px;
                }
            }

        }

        .swiper-wrap,
        .swiper-wrap-sigle,
        .swiper-draw-zone {
            height: 3.733333rem;
            position: relative;
            box-sizing: border-box;
            overflow: hidden;

            .swiper-list {
                margin: 0 0.4rem;
                display: flex;

                .swiper-box-item {
                    position: relative;
                    display: flex;
                    margin-right: 0.266667rem;
                }

            }

            &.swiper-wrap-sigle {
                height: auto;

                img {
                    width: 100%;
                }
            }

            // .title {
            //     z-index: 9;
            //     position: absolute;
            //     font-size: 16px;
            //     font-weight: bold;
            //     left: 0.266667rem;
            //     top: 0.266667rem;
            // }

            &.swiper-full-small {
                height: 5.333333rem;
            }

            &.swiper-full-big {
                height: 6.666667rem;
            }

            &.swiper-full-smallNew {
                height: 2.4rem;
            }

            &.swiper-full-auto,
            &.swiper-draw-zone {
                height: auto;

                .swiper-slide {
                    height: auto;
                    position: relative;

                    .slider-img {
                        vertical-align: top;
                        height: auto;
                        display: block;
                    }

                    .zone {
                        position: absolute;

                    }
                }

            }

            &.swiper-between {
                height: auto;
            }

            .swiper-slide {
                width: 100%;
                height: 100%;
                transform: translate3d(0, 0, 0);

                .slider-img {
                    vertical-align: top;
                    width: 100%;
                    height: 100%;
                }

            }

            .dots {
                position: absolute;
                left: 0;
                z-index: 99;
                right: 0;
                bottom: 0.373333rem;
                display: flex;
                justify-content: center;

                &.hasModules {
                    bottom: 1.333333rem;
                }

                .swiper-pagination-bullet {
                    margin: 0 0.08rem;
                    width: 0.133333rem;
                    height: 0.133333rem;
                    border-radius: 50%;
                    opacity: 0.5;
                    background: #fff;
                }

                .swiper-pagination-bullet-active {
                    background: #fff;
                    opacity: 1;
                }
            }
        }

        .navbar {
            margin: -0.933333rem auto 0;
            z-index: 9;
            width: 92%;
            border-radius: 0.266667rem;
            padding-top: 0.133333rem;
            position: relative;
            background: #ffffff;
            // box-shadow: 0 6px 12px 0 rgba(74, 112, 196, 0.06);

            .navbar-list {
                display: flex;
                flex-wrap: wrap;

                .navbar-item {
                    padding: 0.266667rem 0;
                    display: flex;
                    flex-direction: column;
                    align-items: center;
                    justify-content: center;
                    width: 25%;

                    &.navbar-item-five {
                        width: 20%;

                        img {
                            height: 0.95rem;
                            width: 0.95rem;
                        }
                    }

                    img {
                        height: 1.066667rem;
                        width: 1.066667rem;
                    }

                    p {
                        margin-top: 0.133333rem;
                        line-height: 0.453333rem;
                        font-size: 12px;
                        color: #1d1e2c;
                    }
                }
            }

            .customBtnBox {
                padding: 0.533333rem 0.613333rem 0.746667rem;
            }

            .customBtn {
                display: flex;

                align-items: center;
                justify-content: center;

                background: #336DE6;
                font-family: PingFangSC-Semibold;
                font-size: 16px;
                color: #FFFFFF;
                letter-spacing: 1px;
                font-weight: 600;
                border-radius: 0.64rem;
                height: 1.28rem;
            }
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/polymerization/CarouselSlide.vue